// Import all your components here
// But don't code inside this file.
// camelCase your file name

// Utilities first so you can use it through all your other files
import './utils/polyfills';
import './utils/tables';
import './utils/youtubeIframe';


// Global files next, to use everywhere. Potentially needing utilities.
// Don't forget all the dependencies needed by your framework.
// Foundation needs jQuery & what-input to work.
import $ from 'jquery';
import 'what-input';
import './global/foundation';

// This is needed to init foundation with all the modules loaded in the
// `./global/foundation` file.
window.addEventListener('load', () => {
  $(document).foundation();
});


// Lastly your components
import './components/customRadios';
import './components/mobileMenu';
import './components/pageStandard';
import './components/searchbar';


// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}


// Signed by Choosit!
console.log(`%c Made with ❤️ by Choosit! `, `background-color: #009ee0; color: white;`);
